module.exports = __webpack_public_path__ + "static/media/bg_dark.5ddb0fe1.svg";